module.exports = __webpack_public_path__ + "img/chats-zero-state.3e2ef9b9.svg";